<app-edit-user [user]="user" [full]="true" [submissionMode$]="submissionMode.EDIT"></app-edit-user>
